import { render, staticRenderFns } from "./TriviaQuizQuestion.vue?vue&type=template&id=6a49b0f8"
import script from "./TriviaQuizQuestion.vue?vue&type=script&lang=js"
export * from "./TriviaQuizQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports